'use es6';

import PropTypes from 'prop-types';
import MomentDate from '../propTypes/MomentDate';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DisplayValueText(props) {
  const {
    value
  } = props;
  return value ? /*#__PURE__*/_jsx("span", {
    children: value
  }) : null;
}
DisplayValueText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string, MomentDate])
};